export const TEST_ID = 'tabs';
